import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function ScanPointSettingsForm(props) {
    const { t } = useTranslation();
    const { loading, index, values, errors, touched, handleInputChange } = props;

    function _hasErrors(key) {
        if(!errors || !touched || !touched[index] || !errors[index]) {
            return false;
        }
        return errors[index][key] && touched[index][key];
    }

    return (
        values ?
            <React.Fragment>
                <Form.Group as={Row} controlId={`scanPoints[${index}]["name"]`} className="required">
                    <Form.Label column sm={3}>{t('general.name')}</Form.Label>
                    <Col sm={9}>
                        <Form.Control
                            onChange={handleInputChange}
                            value={values.name || ''}
                            disabled={loading}
                            isInvalid={_hasErrors('name')}
                        />
                        {_hasErrors('name') ? (
                            <Form.Control.Feedback type="invalid">
                                {errors[index]['name']}
                            </Form.Control.Feedback>
                        ) : null}
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId={`scanPoints[${index}]["description"]`}>
                    <Form.Label column sm={3}>{t('general.description')}</Form.Label>
                    <Col sm={9}>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            onChange={handleInputChange}
                            value={values.description || ''}
                            disabled={loading}
                        />
                    </Col>
                </Form.Group>
               {/*  <Row>
                    <Form.Label column sm={3}>Asetukset</Form.Label>
                    <Col sm={9}>
                        <Form.Check type="checkbox" id={`scanPoints[${index}]["commentsEnabled"]`} onChange={handleInputChange} value={values.commentsEnabled} defaultChecked={values.commentsEnabled} label=" Salli kommentit" />
                        <Form.Check type="checkbox" id={`scanPoints[${index}]["qrEnabled"]`} onChange={handleInputChange} value={values.qrEnabled} defaultChecked={values.qrEnabled} label=" Salli QR-koodit" />
                    </Col>
                </Row> */}
            </React.Fragment>
        : null
    )

}

export default ScanPointSettingsForm;

